import { Product, type ProductOpaqueValue } from "@b2bportal/purchase-api";
import { getObjectKeysAsObject } from "@checkout/helpers";
import { ParentState } from "@checkout/types";
import { assign } from "xstate";
import { getCfarCartUpdateRequest } from "./selectors";
import type {
  HtsAirCfarProduct,
  PartialParentContextWithHtsAirCfar,
} from "./types";

export const actions = {
  addHtsCfarProduct: assign(
    (context: PartialParentContextWithHtsAirCfar, _event: unknown) => {
      const filterOutCfarFromProducts = (
        context[ParentState.cartUpdate].addProducts ?? []
      ).filter((p: ProductOpaqueValue) => p.type !== Product.HtsAirCfar);

      const request = getCfarCartUpdateRequest({ context });
      const newCfarProduct: HtsAirCfarProduct = {
        type: Product.HtsAirCfar,
        value: request,
      };

      context[ParentState.cartUpdate].addProducts = [
        ...filterOutCfarFromProducts,
        newCfarProduct,
      ];

      return context;
    }
  ),
};

export const ActionTypes = getObjectKeysAsObject(actions);
